import { getState } from '~src/state';
import { clearAllSpellCheckErrors } from '~core/spellcheck';
import { getSnapManager, updateSnappingOptions } from '~core/snapping';
import { getAlignmentManager } from '~core/alignment';
import { DEFAULT_SETTINGS } from './constants';

export function applySettings() {
  const settings = getState('settings') || DEFAULT_SETTINGS;

  // Handle spell check state changes
  if (window.canvas) {
    if (!settings.spellCheckEnabled) {
      // Clear all spell check errors if spell check is disabled
      clearAllSpellCheckErrors(window.canvas);
    }
  }

  // Handle alignment lines and snapping settings
  const snapManager = getSnapManager();
  if (snapManager) {
    updateSnappingOptions({
      enableObjectSnapping: settings.snappingEnabled,
      enableCenterSnapping: settings.snappingEnabled,
      enableCanvasEdgeSnapping: settings.snappingEnabled,
      enableGuidelineSnapping: settings.snappingEnabled,
      // Alignment lines should work independently
      showAlignmentLines: settings.alignmentLinesEnabled,
    });
  }

  // Update the new alignment manager
  const alignmentManager = getAlignmentManager();
  if (alignmentManager) {
    alignmentManager.updateOptions({
      showAlignmentLines: settings.alignmentLinesEnabled,
      enableObjectAlignment:
        settings.alignmentLinesEnabled &&
        settings.objectAlignmentLinesEnabled !== false,
      enableCenterAlignment:
        settings.alignmentLinesEnabled &&
        settings.canvasAlignmentLinesEnabled !== false,
      showDistanceMeasurements: settings.showDistanceMeasurements,
    });

    // Clear alignment lines immediately if disabled
    if (!settings.alignmentLinesEnabled) {
      alignmentManager.clearAlignmentLines();
    }
  }

  // Also update the global config for other alignment systems
  if (window.editorConfig && window.editorConfig.snapSettings) {
    window.editorConfig.snapSettings.enableObjectSnapping =
      settings.snappingEnabled;
    window.editorConfig.snapSettings.enableCenterSnapping =
      settings.snappingEnabled;
    window.editorConfig.snapSettings.enableCanvasEdgeSnapping =
      settings.snappingEnabled;
    window.editorConfig.snapSettings.enableGuidelineSnapping =
      settings.snappingEnabled;
  }
}
